import { useMemo } from "react";
import { trpc } from "../trpc";

export function useQuerySupportedAssets() {
  const { data, isLoading } = trpc.folder.getSupportedAssets.useQuery(
    undefined,
    {
      staleTime: 600_000, // 10 minute stale time
      gcTime: 600_000, // 10 minute gc time
    },
  );

  const supportedAssets = useMemo(
    () => data?.supportedTypes || ([] as string[]),
    [data],
  );

  return {
    supportedAssets,
    isLoading,
  };
}
